export enum MandatoryAttributes {
  language = 'language',
}
